import { auth0Options } from "./auth0";

let instance;
export const getInstance = () => instance;
export const Auth0Plugin = {
  install(Vue, options) {
    if (!instance) instance = new Vue(auth0Options(options));
    Vue.prototype.$auth = instance;
  },
};
